import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MsgDataService from "../services/MsgService";
import { messageNotificationAction } from "../reducers/MessageNotificationReducer";
import { getParentNotificationCount } from "../utils/parentNotificationCount";
import { Roles } from "../utils/Roles";

const useParentChildNotificationCount = ({ autoRefresh = true } = {}) => {
  const dispatch = useDispatch();
  const isImpersonating = useSelector((state) => state.ImpersonationReducer?.isImpersonating);
  const user = useSelector((state) => state.UserReducer.userObj);
  const isParent = user?.role === Roles.PARENT_NAME;

  const refresh = useCallback(() => {
    if (!isParent || isImpersonating) return;
    MsgDataService.getTotalParentCount()
      .then((res) => {
        if (res?.status !== 200) return;
        dispatch(messageNotificationAction(getParentNotificationCount(res?.data)));
      })
      .catch(() => {});
  }, [dispatch, isImpersonating, isParent]);

  useEffect(() => {
    if (!autoRefresh) return;
    refresh();
  }, [autoRefresh, refresh]);

  return { refresh };
};

export default useParentChildNotificationCount;
